import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
  /** Use '_top' for external links (e.g. checkout) so they leave any embedding frame. */
  target?: '_top' | '_blank' | '_self';
};

/**
 * Sunrise Coral es el color de acción de la página (texto Night Indigo
 * encima, contraste ~5:1). Signal Red queda reservado para seguridad.
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg',
  target
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-[17px] sm:text-xl rounded-full min-h-[60px]' : 'px-5 py-3 text-sm rounded-full';
  return <a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} className={`inline-flex w-full items-center justify-center gap-2 text-center font-display bg-coral hover:bg-coral-hover text-night font-bold tracking-wide shadow-card hover:shadow-lift transition-[background-color,box-shadow] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-saffron/70 ${sizing} ${className}`} data-id="element-112" data-mp="vba9s01e31r4">
      {children}
    </a>;
}